import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Tyre'}
      url={'tyre'}
      queryKey="tyres"
      title={'Tyre'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
